// React
import React, { Children } from "react";

// External libraries
import { useAutoAnimate } from "@formkit/auto-animate/react";

// Internal
import { isNullOrUndefined } from "../functions/general";

// CSS
import "./forms.css";

function FormColumn(props) {
    const [body, enableAnimations] = useAutoAnimate();

    const getWidth = () => {
        const columnWidth = props.ColumnWidths[props.ColumnNumber % props.ColumnWidths.length];
        const totalWidth = props.ColumnWidths.reduce((a, b) => a + b, 0);
        const percentageWidth = 100 * columnWidth / totalWidth;
        const margin = props.Margin || 12;
        const marginOffset = (margin * (props.ColumnWidths.length - 1)) / props.ColumnWidths.length;
        return `calc(${percentageWidth}% - ${marginOffset}px)`;
    };

    const getMargin = () => {
        if (props.ColumnNumber % props.ColumnWidths.length === 0) return 0;
        return props.Margin || 12;
    };

    const getStyle = () => {
        let style = {
            width: getWidth(),
            marginLeft: getMargin()
        }
        if (props.Height) {
            style.height = props.Height;
        }
        if (props.Grow) {
            style.flexGrow = 1;
        }
        return style;
    };

    if (props.Skeleton) {
        return (
            <div className="eone-ui-form-column" style={getStyle()}>
                {React.cloneElement(props.Column, { Skeleton: true })}
            </div>
        );
    }

    if (props.Animate) {
        return (
            <div className="eone-ui-form-column" style={getStyle()} ref={body}>
                {props.Column}
            </div>
        );
    }

    return (
        <div className="eone-ui-form-column" style={getStyle()}>
            {props.Column}
        </div>
    );
}

function FormColumns(props) {
    const getColumnWidths = (columnCount) => {
        if (props.ColumnWidths) return props.ColumnWidths;
        if (Array.isArray(props.Columns)) return props.Columns;
        if (Number.isInteger(props.Columns)) return Array(props.Columns).fill(1);
        if (props.Columns === "auto") return Array(columnCount).fill(1);
        return [1];
    };

    const getColumns = () => {
        const columnArray = Children.toArray(props.children);
        let columns = [];
        for (let i = 0; i < columnArray.length; i++) {
            const column = columnArray[i];
            if (!column.props || isNullOrUndefined(column.props.Visible) || column.props.Visible !== false) {
                columns.push(column);
            }
        }
        const columnWidths = getColumnWidths(columns.length);
        return columns.map((column, index) => {
            return (
                <FormColumn
                    key={index}
                    ColumnNumber={index}
                    ColumnWidths={columnWidths}
                    Height={props.ColumnHeight}
                    Column={column}
                    Grow={props.Grow}
                    Skeleton={props.Skeleton}
                    Animate={props.Animate} />
            );
        });
    }

    const getContainerStyle = () => {
        let style = props.Style || {};
        if (props.ColumnHeight) {
            style.height = props.ColumnHeight;
        }
        if (props.Grow) {
            style.flexGrow = 1;
        }
        if(props.Gap) {
            style.gap = props.Gap
        }
        return style;
    };

    if (props.Visible !== undefined && !props.Visible) {
        return null;
    }

    return (
        <div className="eone-ui-form-columns" style={getContainerStyle()}>
            {getColumns()}
        </div>
    )
}

export { FormColumns };